import React, { useEffect } from "react";
import ContentBox from "../../components/ContentBox/ContentBox";
import Heading from "../../components/Heading/Heading";
import { workshops } from "../../data/contents";

function Arduino() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Heading text="Arduino Using Tinkercad" subtext="VYUHAA'23" />
      <ContentBox
        desc={workshops.A.desc}
        venue={workshops.A.venue}
        moreVenue={workshops.A.moreVenue}
        time={workshops.A.time}
        speaker={workshops.A.speaker}
        contacts={workshops.A.contact}
        img_src={workshops.A.img_src}
      />
    </div>
  );
}

export default Arduino;